"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _styles = require("@mui/material/styles");
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireWildcard(require("@mui/material/TableCell"));
var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer"));
var _TableFooter = _interopRequireDefault(require("@mui/material/TableFooter"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _String = _interopRequireDefault(require("./String"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledTableCell = (0, _styles.styled)(_TableCell.default)(({
  theme
}) => ({
  [`&.${_TableCell.tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.common.black
  }
}));
const Table = /*#__PURE__*/(0, _react.memo)(({
  items,
  fields,
  footer,
  size,
  tableClassName,
  stickyHeader
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer.default, {
    component: _Paper.default,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table.default, {
      className: tableClassName,
      size: size,
      stickyHeader: stickyHeader,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableRow.default, {
          children: fields.map((field, key) => /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTableCell, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
              bold: true,
              noFlex: true,
              str: field.label
            })
          }, key))
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableBody.default, {
        children: items.map((item, key) => {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableRow.default, {
            children: fields.map((field, key) => {
              let fieldChildren = field.render?.(item, key);
              if (typeof fieldChildren === "string") {
                fieldChildren = /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
                  noFlex: true,
                  str: fieldChildren
                });
              }
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell.default, {
                children: fieldChildren,
                sx: {
                  verticalAlign: field.verticalAlign
                }
              }, key);
            })
          }, key);
        })
      }), footer && /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableFooter.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableRow.default, {
          children: footer
        })
      })]
    })
  });
});
Table.propTypes = {
  items: _propTypes.default.array,
  fields: _propTypes.default.array,
  footer: _propTypes.default.element,
  size: _propTypes.default.oneOf(["small", "medium"]),
  stickyHeader: _propTypes.default.bool,
  tableClassName: _propTypes.default.string
};
Table.defaultProps = {
  size: "small",
  stickyHeader: true
};
var _default = exports.default = Table;